
export default {
    page: {
        name: null,
        content: null,
        slug: null
    }
}